module.exports = __webpack_public_path__ + "portal/assets/img/logo.a9e6e49c.svg";